import { ref } from 'vue'


export const isFirstLoad = ref(true);

export const defaultTableCols = ref([
  // Demande
  {
    label: 'Date de la demande',
    slug: 'demande_date',
    sortable: true
  },
  {
    label: 'Motif',
    slug: 'demande_motif',
    sortable: true
  },
  {
    label: 'Salarié concerné',
    slug: 'demande_salary',
    sortable: true
  },
  {
    label: 'Bénéficiaire concerné',
    slug: 'demande_beneficiary',
    sortable: true
  },
  {
    label: 'Statut de la demande',
    slug: 'demande_status',
    sortable: true
  },
  {
    label: 'Montant',
    slug: 'demande_price',
    sortable: true
  },

  // Payement
  {
    label: 'Motif du paiement',
    slug: 'payment_motif',
    sortable: true
  },
  {
    label: 'Salarié concerné',
    slug: 'payment_salary',
    sortable: true
  },
  {
    label: 'Statut du paiement',
    slug: 'payment_status',
    sortable: true
  },
  {
    label: 'Montant du paiement',
    slug: 'payment_price',
    sortable: true
  },
  {
    label: 'Date du paiement',
    slug: 'payment_date',
    sortable: true
  },

  // Refund
  {
    label: 'Traitement de la demande',
    slug: 'refund_status',
    sortable: true
  },
  {
    label: 'Date de la demande',
    slug: 'refund_date',
    sortable: true
  },
  {
    label: 'Type de demande',
    slug: 'refund_type',
    sortable: true
  },
  {
    label: 'Bénéficiaire concerné',
    slug: 'refund_beneficiary',
    sortable: true
  },
  {
    label: 'Montant',
    slug: 'refund_price',
    sortable: true
  },
  {
    label: 'Complétude du dossier',
    slug: 'refund_complete',
    sortable: true
  },

  // Contribution
  {
    label: 'Période concernée',
    slug: 'contribution_periode',
    sortable: true
  },
  {
    label: 'Montant déclaré',
    slug: 'contribution_declared',
    sortable: true
  },
  {
    label: 'Montant payé',
    slug: 'contribution_paid',
    sortable: true
  },
  {
    label: 'Solde',
    slug: 'contribution_solde',
    sortable: true
  },
  {
    label: 'Type de paiment',
    slug: 'contribution_payment_type',
    sortable: true
  },

  // Affiliation
  {
    label: 'Etat',
    slug: 'affiliation_status',
    sortable: true
  },
  {
    label: "Date d'affiliation",
    slug: 'affiliation_date',
    sortable: true
  },
  {
    label: 'salarié concerné',
    slug: 'affiliation_salary',
    sortable: true
  },

  // Divers
  {
    label: 'DNS à jour ? ',
    slug: 'dsn_updated',
    sortable: true
  },
  {
    label: 'Prénom',
    slug: 'firstname',
    sortable: true
  },
  {
    label: 'Nom',
    slug: 'name',
    sortable: true
  },
  {
    label: 'Email',
    slug: 'email',
    sortable: true
  },
  {
    label: 'Satut',
    slug: 'status',
    sortable: true
  },
  {
    label: 'Documents',
    slug: 'documents'
  },
  {
    label: 'Actions',
    slug: 'actions'
  }
])
